import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import App from './App';
import './index.css';

import NotFoundPage from './pages/404';
import Dashboard from './pages/dashboard';
import Login from './pages/login';
import MerchantsPage from './pages/merchants';
import OfferPage from './pages/offer';
import ProductsPage from './pages/products';
import TrafficSourcesPage from './pages/traffic';
import SingleTrafficPage from './pages/traffic/SingleTraffic';

import GuardedRoute from './components/GuardedRoute';
import AuthProvider from './context/authContext';
import PublishersPage from './pages/Publishers';
import AffiliatePage from './pages/affiliates';
import SingleAffiliatePage from './pages/affiliates/SingleAffiliate';
import SingleQualityReportPage from './pages/affiliates/SingleAffiliate/SingleQualityReport';
import CampaignPage from './pages/campaigns';
import SingleCampaignBlock from './pages/campaigns/CampaignBlock';
import CampaignOfferPage from './pages/campaigns/Offers/OfferTable';
import CronJobsSovrn from './pages/cron-jobs-sovrn';
import SingleCustomReport from './pages/custom-reports/SingleCustomReport';
import DomainPage from './pages/domains';
import FacebookRedirectPage from './pages/facebookRedirect';
import IronDomePage from './pages/ironDome';
import LogsPage from './pages/logs';
import MerchantFeeds from './pages/merchants/MerchantFeeds';
import CustomOfferPage from './pages/offerGroup';
import CustomOffer from './pages/offerGroup/CustomOffer';
import OfferGroupClicks from './pages/offerGroup/OfferGroupClicks';
import OfferGroupReport from './pages/offerGroup/OfferGroupReport';
import OfferGroupSettings from './pages/offerGroup/OfferGroupSettings';
import SingleOfferGroup from './pages/offerGroup/SingleOfferGroup';
import PostbackPage from './pages/postback';
import RedirectPage from './pages/redirect';
import RequestPage from './pages/request';
import SovrnPage from './pages/sovrn';
import SingleSovrnReportPage from './pages/sovrn/SingleSovrn';
import SingleTrafficBlock from './pages/traffic/TrafficBlock';
import WizardPage from './pages/wizard';
import BulkWizardPage from './pages/wizard/BulkWizardPage';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const router = createBrowserRouter([
  {
    path: '/r/:id',
    element: <RedirectPage />,
  },
  {
    path: '/fb',
    element: <FacebookRedirectPage />,
  },
  {
    path: '/',
    element: <App />,
    children: [
      {
        index: true,
        element: (
          <GuardedRoute>
            <Dashboard />
          </GuardedRoute>
        ),
      },
      {
        path: 'logs',
        element: (
          <GuardedRoute>
            <LogsPage />
          </GuardedRoute>
        ),
      },
      {
        path: 'postback',
        element: (
          <GuardedRoute>
            <PostbackPage />
          </GuardedRoute>
        ),
      },
      {
        path: 'offers',
        element: (
          <GuardedRoute>
            <OfferPage />
          </GuardedRoute>
        ),
      },
      {
        path: 'merchants',
        element: (
          <GuardedRoute>
            <MerchantsPage />
          </GuardedRoute>
        ),
      },
      {
        path: 'traffic',
        element: (
          <GuardedRoute>
            <TrafficSourcesPage />
          </GuardedRoute>
        ),
      },
      {
        path: 'traffic/:sourceId',
        element: (
          <GuardedRoute>
            <SingleTrafficPage />
          </GuardedRoute>
        ),
      },
      {
        path: 'traffic/:sourceId/block',
        element: (
          <GuardedRoute>
            <SingleTrafficBlock />
          </GuardedRoute>
        ),
      },
      {
        path: 'login',
        element: <Login />,
      },
      {
        path: 'domains',
        element: (
          <GuardedRoute>
            <DomainPage />
          </GuardedRoute>
        ),
      },
      {
        path: 'publishers',
        element: (
          <GuardedRoute>
            <PublishersPage />
          </GuardedRoute>
        ),
      },
      {
        path: 'affiliates',
        element: (
          <GuardedRoute>
            <AffiliatePage />
          </GuardedRoute>
        ),
      },
      {
        path: 'affiliates/:affiliateId',
        element: (
          <GuardedRoute>
            <SingleAffiliatePage />
          </GuardedRoute>
        ),
      },
      {
        path: 'qualityEntry/:qualityEntryId',
        element: (
          <GuardedRoute>
            <SingleQualityReportPage />
          </GuardedRoute>
        ),
      },
      {
        path: 'merchants/:merchantId/feeds',
        element: (
          <GuardedRoute>
            <MerchantFeeds />
          </GuardedRoute>
        ),
      },
      {
        path: 'products',
        element: (
          <GuardedRoute>
            <ProductsPage />
          </GuardedRoute>
        ),
      },
      {
        path: 'sovrn',
        element: (
          <GuardedRoute>
            <SovrnPage />
          </GuardedRoute>
        ),
      },
      {
        path: 'sovrn/:id',
        element: (
          <GuardedRoute>
            <SingleSovrnReportPage />
          </GuardedRoute>
        ),
      },
      {
        path: 'offer-group',
        element: (
          <GuardedRoute>
            <CustomOfferPage />
          </GuardedRoute>
        ),
      },
      {
        path: 'offer-group/:id',
        element: (
          <GuardedRoute>
            <SingleOfferGroup />
          </GuardedRoute>
        ),
        children: [
          {
            path: '',
            element: <CustomOffer />,
            index: true,
          },
          {
            path: 'reports',
            element: <OfferGroupReport />,
          },
          {
            path: 'settings',
            element: <OfferGroupSettings />,
          },
          {
            path: 'clicks',
            element: <OfferGroupClicks />,
          },
        ],
      },
      {
        path: 'custom-report/:id',
        element: (
          <GuardedRoute>
            <SingleCustomReport />
          </GuardedRoute>
        ),
      },
      {
        path: 'iron-dome',
        element: (
          <GuardedRoute>
            <IronDomePage />
          </GuardedRoute>
        ),
      },
      {
        path: 'request',
        element: (
          <GuardedRoute>
            <RequestPage />
          </GuardedRoute>
        ),
      },
      {
        path: 'cron-jobs',
        element: (
          <GuardedRoute>
            <CronJobsSovrn />
          </GuardedRoute>
        ),
      },
      {
        path: 'campaigns',
        element: (
          <GuardedRoute>
            <CampaignPage />
          </GuardedRoute>
        ),
      },
      {
        path: 'campaigns/:campaignId/offers',
        element: (
          <GuardedRoute>
            <CampaignOfferPage />
          </GuardedRoute>
        ),
      },
      {
        path: 'campaigns/:sourceId/block',
        element: (
          <GuardedRoute>
            <SingleCampaignBlock />
          </GuardedRoute>
        ),
      },
      {
        path: 'wizard',
        element: (
          <GuardedRoute>
            <WizardPage />
          </GuardedRoute>
        ),
      },
      {
        path: 'wizard/bulk',
        element: (
          <GuardedRoute>
            <BulkWizardPage />
          </GuardedRoute>
        ),
      },
      // {
      //   path: 'reporting',
      //   element: (
      //     <GuardedRoute>
      //       <ReportingPage />
      //     </GuardedRoute>
      //   ),
      // },
      {
        path: '/404',
        element: <NotFoundPage />,
      },
    ],
  },
]);

root.render(
  <React.StrictMode>
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </React.StrictMode>
);
